import { render, staticRenderFns } from "./TabProject.vue?vue&type=template&id=63f76ac9&scoped=true&"
import script from "./TabProject.vue?vue&type=script&lang=js&"
export * from "./TabProject.vue?vue&type=script&lang=js&"
import style0 from "./TabProject.vue?vue&type=style&index=0&id=63f76ac9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f76ac9",
  null
  
)

export default component.exports